import handleTranslation from '@/helpers/handleTranslation';

export const translatedMDFValues = {
  // Header
  additionalInformation: handleTranslation(
    'Microsoft Tenant & Admin user information',
    'Informações do tenant e do utilizador administrador'
  ),
  additionalInformationDescription: handleTranslation(
    'Please provide the details to create the Microsoft tenant and admin user account',
    'Por favor, forneça os detalhes para criar o tenant e o utilizador administrador da Microsoft'
  ),

  // Labels
  microsoftTenantName: handleTranslation('Microsoft tenant name', 'Nome do tenant da Microsoft'),
  userPrincipleName: handleTranslation('User principle name', 'Nome do utilizador principal'),
  email: handleTranslation('Email', 'E-mail'),
  alternateEmail: handleTranslation('Alternate Email address', 'E-mail alternativo'),
  firstName: handleTranslation('First Name', 'Nome'),
  lastName: handleTranslation('Last name', 'Apelido'),
  businessName: handleTranslation('Business Name', 'Nome da empresa ou Empresário em Nome Individual'),
  address: handleTranslation('Address', 'Morada'),
  address2: handleTranslation('Address 2', 'Continuação da morada'),
  zipCode: handleTranslation('ZipCode', 'Código postal'),
  city: handleTranslation('City', 'Cidade'),
  country: handleTranslation('Country', 'País'),
  county: handleTranslation('County', 'Distrito'),
  phoneNumber: handleTranslation('Phone Number', 'Número de telefone'),
  organizationRegistrationNumber: handleTranslation(
    'Organization registration number',
    'Número de registro da organização'
  ),
  consentUserFirstName: handleTranslation('Consent User - First name', 'Utilizador de consentimento - Nome'),
  consentUserLastName: handleTranslation('Consent User - Last name', 'Utilizador de consentimento - Apelido'),
  consentUserEmail: handleTranslation('Consent User - Email', 'Utilizador de consentimento - E-mail'),
  consentUserPhone: handleTranslation('Consent User - Phone Number', 'Utilizador de consentimento - Número de telemóvel'),

  // Placeholders
  tenantNamePlaceholder: handleTranslation('tenantName', 'subdomínio (sem espaços)'),
  usernamePlaceholder: handleTranslation('username', 'Username (sem espaços)'),
  emailPlaceholder: handleTranslation('email', 'Endereço de e-mail'),
  alternateEmailPlaceholder: handleTranslation('alternate Email', 'E-mail alternativo'),
  firstNamePlaceholder: handleTranslation('firstName', 'Nome'),
  lastNamePlaceholder: handleTranslation('lastName', 'Apelido'),
  businessNamePlaceholder: handleTranslation('Your Business Name', 'Nome da empresa'),
  addressPlaceholder: handleTranslation('Your address', 'Morada'),
  address2Placeholder: handleTranslation('Your other address', 'Continuação da morada'),
  zipCodePlaceholder: handleTranslation('zipCode', 'Código postal'),
  cityPlaceholder: handleTranslation('city', 'Cidade'),
  phoneNumberPlaceholder: handleTranslation('Phone Number', '+351 911 1111 11'),
  orgNumberPlaceholder: handleTranslation('Organization registration number', 'Número de Identificação Fiscal'),
  consentFirstNamePlaceholder: handleTranslation('consentFirstName', 'Nome'),
  consentLastNamePlaceholder: handleTranslation('consentLastName', 'Apelido'),
  consentEmailPlaceholder: handleTranslation('Consent User Email', 'Endereço de e-mail'),
  consentPhonePlaceholder: handleTranslation('Consent User Phone Number', '+351 911111111'),

  // Error Messages
  nameIncorrect: handleTranslation(
    'The name is incorrect. Please try again',
    'O subdomain está inválido. Por favor tente outro.'
  ),
  usernameIncorrect: handleTranslation(
    'The Username is incorrect. Please try again',
    'O nome de utilizador está incorreto. Por favor, tente novamente'
  ),
  emailInvalid: handleTranslation(
    'Please enter a valid email address and does not have @Microsoft.com in it',
    'Por favor, insira um endereço de e-mail válido e que não contenha @Microsoft.com'
  ),
  altEmailIncorrect: handleTranslation(
    'The Alternate Email is incorrect. Please try again',
    'O e-mail alternativo está incorreto. Por favor, tente novamente'
  ),
  firstNameIncorrect: handleTranslation(
    'The First name is incorrect. Please try again',
    'O primeiro nome está incorreto. Por favor, tente novamente'
  ),
  lastNameIncorrect: handleTranslation(
    'The Last name is incorrect. Please try again',
    'O sobrenome está incorreto. Por favor, tente novamente'
  ),
  businessNameIncorrect: handleTranslation(
    'The Business name is incorrect. Please try again',
    'O nome da empresa está incorreto. Por favor, tente novamente'
  ),
  addressIncorrect: handleTranslation(
    'The address is incorrect. Please try again',
    'O endereço está incorreto. Por favor, tente novamente'
  ),
  zipCodeIncorrect: handleTranslation(
    'The ZipCode is incorrect. Please try again',
    'O código postal está incorreto. Por favor, tente novamente'
  ),
  cityIncorrect: handleTranslation(
    'The City is incorrect. Please try again',
    'A cidade está incorreta. Por favor, tente novamente'
  ),
  chooseCountry: handleTranslation('Please choose a Country', 'Por favor, escolha um país'),
  chooseCounty: handleTranslation('Please choose a County', 'Por favor, escolha um condado'),
  phoneInvalid: handleTranslation(
    'Please enter a valid phone number (numbers only)',
    'Por favor, insira um número de telefone válido (apenas números)'
  ),
  orgNumberIncorrect: handleTranslation(
    'The Organization registration number is incorrect. Please try again',
    'O número de registo da organização está incorreto. Por favor, tente novamente'
  ),
  fillField: handleTranslation('Please fill this field', 'Por favor, preencha este campo'),

  // Info Messages
  tenantNameInfo: handleTranslation(
    'You can find your tenant name on your Microsoft portal profile.',
    'Pode encontrar o nome do tenant no perfil do portal da Microsoft.'
  ),
  accessTenantName: handleTranslation(
    'Access your tenant name by clicking here',
    'Acesse o nome do tenant clicando aqui'
  ),

  // Select Options
  selectCountry: handleTranslation('Select Country', 'Selecione o país'),
  selectCounty: handleTranslation('Select County', 'Selecione o distrito'),
  loadingCounties: handleTranslation('Loading counties...', 'A carregar condados...'),

  // Buttons
  cancel: handleTranslation('Cancel', 'Cancelar'),
  saveDetails: handleTranslation('Save Details', 'Guardar detalhes'),

  // Info Messages
  missingOrIncorrectInformation: handleTranslation(
    'There is missing or incorrect information',
    'Existe informação em falta ou incorreta.'
  ),

  // MCA State Notification
  mcaStateHeading: handleTranslation(
    'Microsoft requires additional information',
    'A Microsoft requer informações adicionais'
  ),
  mcaStateDescription: handleTranslation(
    'Accept the Microsoft Customer Agreement to proceed',
    'Aceite o Contrato de Cliente da Microsoft para prosseguir'
  ),

  // Edit Microsoft Data Form - Modal
  editMicrosoftModalTitle: handleTranslation(
    'Microsoft requires additional information',
    'A Microsoft requer informações adicionais'
  ),
  editMicrosoftModalSubtitle: handleTranslation(
    'Follow the required steps below to continue with your purchase',
    'Preencha as informações abaixo para poder prosseguir com a sua compra'
  ),
  mcaInfoText: handleTranslation(
    'You will need to review and accept the Microsoft Customer Agreement to proceed.',
    'É necessário rever e aceitar o Acordo de Cliente Microsoft'
  ),
  // MCA Form Section - Customer Information
  customerInformation: handleTranslation('Customer information', 'Dados do cliente'),
  customerInformationDescription: handleTranslation(
    'Enter the details of someone authorized on behalf of your organization to sign legal documents and/or terms and conditions',
    'Indique os dados da pessoa responsável pela assinatura de documentos legais e/ou termos e condições em nome da organização.'
  ),
  enterFirstNamePlaceholder: handleTranslation('Enter first name', 'Nome'),
  enterLastNamePlaceholder: handleTranslation('Enter last name', 'Apelido'),
  enterPhoneNumberPlaceholder: handleTranslation('Enter phone number', '+351 911111111'),
  enterEmailAddressPlaceholder: handleTranslation('Enter email address', 'Endereço de e-mail'),
  emailAgreementInfo: handleTranslation(
    'You will receive a link with the agreement to this address',
    'Receberá uma ligação com o acordo neste endereço'
  ),
  selectCountryMCA: handleTranslation('Select country', 'Selecione o país'),
  ireland: handleTranslation('Ireland', 'Irlanda'),
  portugal: handleTranslation('Portugal', 'Portugal'),

  // MCA Form Section - Validation Errors
  firstNameRequired: handleTranslation('First name is required', 'O primeiro nome é obrigatório'),
  lastNameRequired: handleTranslation('Last name is required', 'O apelido é obrigatório'),
  firstNameMinLength: handleTranslation(
    'First name must be at least 2 characters',
    'O primeiro nome deve ter pelo menos 2 caracteres'
  ),
  lastNameMinLength: handleTranslation(
    'Last name must be at least 2 characters',
    'O apelido deve ter pelo menos 2 caracteres'
  ),
  firstNameInvalidChars: handleTranslation(
    'First name can only contain letters, spaces, hyphens and apostrophes',
    'O primeiro nome só pode conter letras, espaços, hífens e apóstrofos'
  ),
  lastNameInvalidChars: handleTranslation(
    'Last name can only contain letters, spaces, hyphens and apostrophes',
    'O apelido só pode conter letras, espaços, hífens e apóstrofos'
  ),
  emailRequired: handleTranslation('Email is required', 'O e-mail é obrigatório'),
  mcaEmailInvalid: handleTranslation('Please enter a valid email address', 'Por favor, introduza um endereço de e-mail válido'),
  microsoftEmailNotAllowed: handleTranslation(
    'Microsoft email addresses are not allowed',
    'Endereços de e-mail da Microsoft não são permitidos'
  ),
  phoneRequired: handleTranslation('Phone number is required', 'O número de telefone é obrigatório'),
  phoneMinLength: handleTranslation(
    'Phone number must be at least 10 digits',
    'O número de telefone deve ter pelo menos 10 dígitos'
  ),
  mcaPhoneInvalid: handleTranslation('Please enter a valid phone number', 'Por favor, introduza um número de telefone válido'),
  countryRequired: handleTranslation('Country is required', 'O país é obrigatório'),

  // MCA Form Section - Alerts
  fillAllFieldsAlert: handleTranslation(
    'Please fill all required fields correctly before proceeding',
    'Por favor, preencha todos os campos obrigatórios corretamente antes de continuar'
  ),
  agreementUrlFailedAlert: handleTranslation(
    'Failed to get agreement URL. Please try again.',
    'Falha ao obter o URL do acordo. Por favor, tente novamente.'
  ),
  agreementErrorAlert: handleTranslation(
    'An error occurred while opening the agreement. Please try again.',
    'Ocorreu um erro ao abrir o acordo. Por favor, tente novamente.'
  ),

  // MCA Form Section - Accept Agreement
  acceptMCA: handleTranslation('Accept the Microsoft Customer Agreement', 'Aceitar o Acordo de Cliente Microsoft'),
  acceptMCADescription: handleTranslation(
    'Completing this action will enable you to purchase Microsoft Products',
    'Concluir esta ação permitirá que compre produtos Microsoft'
  ),
  openAgreement: handleTranslation('Open Agreement', 'Abrir acordo'),
  openAgreementInfo: handleTranslation(
    'A new tab will open for you to complete this step on the Microsoft website. Ensure that you return to this tab after submitting to continue your purchase.',
    'Será aberta uma nova janela para completar este passo no site da Microsoft. Certifique-se de que regressa a esta janela após submeter para continuar a sua compra.'
  ),

  // MCA Form Section - Verify Agreement
  verifyAcceptanceStatus: handleTranslation(
    'Verify the acceptance status of the Agreement',
    'Verificar o estado de aceitação do Acordo'
  ),
  verifyAcceptanceDescription: handleTranslation(
    'To continue with your purchase, click "Verify Status" to ensure the agreement is accepted.',
    'Para continuar com a sua compra, clique em "Verificar Estado" para garantir que o acordo foi aceite.'
  ),
  verifying: handleTranslation('Verifying...', 'A verificar...'),
  verifyStatus: handleTranslation('Verify Status', 'Verificar estado'),
  statusVerified: handleTranslation('Status verified. Move on to the next step.', 'Estado verificado. Avance para o próximo passo.'),
  verificationFailed: handleTranslation(
    "The agreement couldn't be validated. Ensure you have accepted the agreement and try verifying it again.",
    'O acordo não pôde ser validado. Certifique-se de que aceitou o acordo e tente verificar novamente.'
  ),

  tenantPortingRequiredSubtitle: handleTranslation(
    'Before proceeding with the purchase of your Microsoft Business license you will need to create a Microsoft profile. Fill in the next fields to create your new Microsoft account.',
    'Antes de prosseguir com a compra da sua licença Microsoft Business, você precisará criar um perfil Microsoft. Preencha os campos a seguir para criar sua nova conta Microsoft.'
  ),
  tenantPortingRequiredTitle: handleTranslation(
    'Microsoft account creation',
    'Criação de conta Microsoft'
  ),

  Basket: handleTranslation('Basket', 'Carrinho'),
  Review:handleTranslation('Review', 'Finalizar compra'),
  OrderConfirmation: handleTranslation('Order Confirmation', 'Confirmação de compra'),

  monthly: handleTranslation('Monthly', 'Valor mensal'),
  upfront:handleTranslation('Upfront', 'Valor inicial'),
  exVal:handleTranslation('ex VAT', 's/IVA'),
  YourOrderSummary: handleTranslation('Your order summary', 'Os seus produtos'),
  ApplyDiscountCode: handleTranslation('Apply discount code', 'Inserir código de desconto'),
  EnterCode:handleTranslation('Enter code', 'Código de desconto'),
  Apply:handleTranslation('Apply', 'Aplicar'),
  Subtotal: handleTranslation('Subtotal', 'Subtotal'),
  EstimatedVAT:handleTranslation('Estimated VAT', 'IVA'),
  DueNow:handleTranslation('Due now', 'Valor a pagar hoje'),
  DueNowNote:handleTranslation('Price reflects one-time and prorated recurring charges, if applicable', 'Este valor corresponde apenas aos dias de utilização efetiva do serviço'),
  EstimatedRecurringCharges:handleTranslation('Estimated recurring charges','Valor mensal contratado'),
  DuemMonthlyExcludingTax:handleTranslation('Due monthly (excluding tax)', 'Valor mensal (s/IVA)'),
  TotalCost:handleTranslation('Total cost', 'Custo total'),
  ContinueShopping:handleTranslation('Continue shopping', 'Continuar a comprar'), 
  RequestCallback:handleTranslation('Request a callback', 'Solicitar contacto de um consultor'),
  CompletePurchase:handleTranslation('Complete Purchase', 'Completar compra'), 
  Edit:handleTranslation('Edit','Editar'),
  Terms: handleTranslation('Terms and Conditions', 'Termos e condições'),
  Privacy:handleTranslation('Privacy Supplement Current','Política de Privacidade'),
  TermsLink:handleTranslation('https://n.vodafone.ie/content/dam/gowingmyself/pdfs/vbu-pdfs-2023/Vodafone%20Business%20Marketplace%20Terms-%20as%20of%20February%202023.pdf','https://www.vodafone.pt/info/termos-condicoes/microsoft-office-365.html'),
  PrivacyLink:handleTranslation("https://n.vodafone.ie/privacy.html","https://www.vodafone.pt/info/termos-condicoes/microsoft-office-365.html#privacidade_panel"),
  ApplyADiscountCode: handleTranslation('Apply discount code', 'Inserir código de desconto'),

};
